'use client';
import e$1 from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

let e = {
    skin: e$1.oneOf([
        'standard',
        'product',
        'circular'
    ]),
    layout: e$1.oneOf([
        'vertical',
        'horizontal'
    ]),
    imageWidth: e$1.oneOf([
        'standard',
        'full-bleed'
    ])
};
const StandardTile = createComponent({
    displayName: 'StandardTile',
    root: 'div',
    propTypes: e,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.standardTile,
    propConfig: {
        classNames ({ skin: a = 'standard', layout: t = 'vertical', imageWidth: d = 'standard' }) {
            let e = new Set([
                'swan-standard-tile'
            ]);
            return 'standard' !== a && e.add(`swan-standard-tile-skin-${a}`), 'horizontal' === t && e.add('swan-standard-tile-horizontal'), 'full-bleed' === d && 'product' === a && e.add('swan-standard-tile-full-bleed'), e;
        }
    }
});

export { StandardTile };
